import { TFetchError } from '@/api/api-error.types';

/**
 * Extracts a human-readable error message from an API error response.
 *
 * Priority:
 * 1. `data.details` — specific domain error (e.g. "The provided password is incorrect")
 * 2. `data.validationErrors[0].constraints.*` — first validation constraint message
 * 3. `message` — generic fallback message from the server
 * 4. `fallback` — default string if nothing else is available
 */
export const getApiErrorMessage = (error: TFetchError, fallback = ''): string => {
  if (error?.data?.data?.details) {
    return error.data.data.details;
  }

  const validationErrors = error?.data?.data?.validationErrors;
  if (validationErrors?.length) {
    const constraints = validationErrors[0]?.constraints;
    if (constraints) {
      const firstMessage = Object.values(constraints)[0];
      if (firstMessage) return firstMessage;
    }
  }

  return error?.data?.message || fallback;
};
